export const firstMileMenuItems = [
  { label: "AWB", path: "/operations/awb" },
  { label: "Pickup Request", path: "/operations/pickup-request" },
  { label: "Pickup Dashboard", path: "/operations/pickup-request/dashboard" },
  { label: "Pickup Request Sheet", path: "/operations/pickup-request-sheet" },
  { label: "Label Print", path: "/operations/label-print" },
  { label: "Docket", path: "/master/dockets" },

 // { label: "Add Shipment", path: "/operations/awb/create" },
 // { label: "View Shipment", path: "/operations/awb" },
 // { label: "Bulk Shipment Upload", path: "/operations/zone" },
 // { label: "Pending Forwarder", path: "/operations/drivers" },
// { label: "View Forwarder Shipment", path: "/operations/modes" },
 // { label: "Pickup-In Scan", path: "/operations/tat" },
 // { label: "Branch In Scan ", path: "/operations/packageTypes" },
 // { label: "PRQ Pending", path: "/operations/departments" },

];